import { createSlice } from '@reduxjs/toolkit';
import { useAppSelector } from '../../hooks';
const initialState = {};
export const zigbeeAttributesSlice = createSlice({
    name: 'attributes',
    initialState,
    reducers: {
        zigbeeAttributeUpdated: {
            reducer: (s, action) => {
                s[action.payload.key] = Object.assign({ typedValue: action.payload.typedValue }, (action.payload.ts !== undefined && { ts: action.payload.ts }));
            },
            prepare: (nid, eid, cid, a) => {
                return {
                    payload: Object.assign({ key: zigbeeAttributeLookupKey(nid, eid, cid, a.attribute_id), typedValue: a.typedValue }, (a.changed !== undefined && { ts: a.changed }))
                };
            }
        }
    }
});
function zigbeeAttributeLookupKey(nid, eid, cid, aid) {
    return nid.toString() + ' ' + eid.toString() + ' ' + cid.toString() + ' ' + aid.toString();
}
export function useAttributeState(nid, eid, cid, aid) {
    const key = zigbeeAttributeLookupKey(nid, eid, cid, aid);
    const attr = useAppSelector(state => state.zigbee.attributes[key]);
    return attr;
}
export const { zigbeeAttributeUpdated } = zigbeeAttributesSlice.actions;
export default zigbeeAttributesSlice.reducer;
